// The main App entry point
import useMediaQuery from "@mui/material/useMediaQuery"
import theme from "css/theme/light"
import AppBar from "./AppBar/AppBar"
import SideDrawer from "./SideDrawer/SideDrawer"

const Navigation = () => {
  const matches = useMediaQuery(theme.breakpoints.up("sm"))
  // const [open, setOpen] = React.useState(matches ? true : false)
  // const toggleDrawer = () => setOpen(!open)
  // useEffect(() => {
  //   setOpen(matches ? true : false)
  // }, [matches])
  return (
    <>
      <AppBar />

      <SideDrawer matches={matches} />
    </>
  )
}

export default Navigation
